module.exports = (__parcel__import__("7w0io")).then(() => parcelRequire('fyWP3'));